export enum StatusEnum {
  REFUSED = 'REFUSED',
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  ACTION_REQUIRED = 'ACTION_REQUIRED',
  REFUNDED = 'REFUNDED',

  FINALIZED = 'FINALIZED',
}

export const statusLabels: Record<StatusEnum, string> = {
  [StatusEnum.PENDING]: 'Em andamento',
  [StatusEnum.COMPLETED]: 'Pago',
  [StatusEnum.REFUSED]: 'Recusado',
  [StatusEnum.REFUNDED]: 'Estorno',
  [StatusEnum.ACTION_REQUIRED]: 'Ação necessária',
  [StatusEnum.FINALIZED]: 'Finalizado',
}

export const optionsStatusSelect = [
  { value: StatusEnum.COMPLETED, label: 'Pago' },
  { value: StatusEnum.PENDING, label: 'Em andamento' },
  { value: StatusEnum.REFUSED, label: 'Recusado' },
  { value: StatusEnum.ACTION_REQUIRED, label: 'Ação necessária' },
  { value: StatusEnum.REFUNDED, label: 'Estorno' },
]
